export const environment = {
    production: false,
    apiUrl: 'https://api.pay.stage.patriamed.de/api/v1/',
    authUrl: 'https://api.portals-auth.stage.patriamed.de/api/v1/'
};
